import {
  GET_OKR_LIST,
  GET_OKR_DETAIL,
  GET_OKR_RESPONSE,
  GET_LIST_PROCESS,
  GET_LIST_MEASURENMENT,
  GET_PT_OBJECTIVE_LIST,
  GET_PT_KEYRESULT_LIST,
  GET_PT_INITIATIVE_LIST,
  GET_PT_HIERARCHY,
  GET_TEMPORARY_ASSIGNMENT,
  GET_OKR_STATUS,
} from '_revamp/redux/action/admin/okr';

const initialState = {
  data: [],
  detail: {},
  response: {},
  measurenment: [],
  process: [],
  objectiveList: [],
  keyresultList: [],
  initiativeList: [],
  hierarchy: [],
  temporaryAssignment: [],
  status_list: [],
};

const auth = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_OKR_LIST: {
      return {
        ...state,
        data: payload.rows,
      };
    }

    case GET_OKR_DETAIL: {
      return {
        ...state,
        detail: payload,
      };
    }

    case GET_OKR_RESPONSE: {
      return {
        ...state,
        response: payload,
      };
    }

    case GET_LIST_MEASURENMENT: {
      return {
        ...state,
        measurenment: payload,
      };
    }

    case GET_LIST_PROCESS: {
      return {
        ...state,
        process: payload,
      };
    }
    case GET_PT_HIERARCHY: {
      return {
        ...state,
        hierarchy: payload,
      };
    }
    case GET_OKR_STATUS: {
      return {
        ...state,
        status_list: payload.rows,
      };
    }

    case GET_PT_OBJECTIVE_LIST: {
      let newPayload = [];
      newPayload = payload?.rows?.map((val) => ({
        value: val.okr_id,
        label: val.title,
      }));
      return {
        ...state,
        objectiveList: newPayload,
      };
    }

    case GET_PT_KEYRESULT_LIST: {
      let newPayload = [];
      newPayload = payload?.rows?.map((val) => ({
        value: val.okr_id,
        label: val.title,
      }));
      return {
        ...state,
        keyresultList: newPayload,
      };
    }

    case GET_PT_INITIATIVE_LIST: {
      let newPayload = [];
      newPayload = payload?.rows?.map((val) => ({
        value: val.okr_id,
        label: val.title,
      }));
      return {
        ...state,
        initiativeList: newPayload,
      };
    }

    case GET_TEMPORARY_ASSIGNMENT: {
      if (payload === 'reset') {
        return {
          ...state,
          temporaryAssignment: [],
        };
      }
      if (payload.delete) {
        return {
          ...state,
          temporaryAssignment: payload.data.assignments,
        };
      }
      return {
        ...state,
        temporaryAssignment: [
          ...state.temporaryAssignment,
          ...payload.data.assignments,
        ],
      };
    }

    default:
      return state;
  }
};

export default auth;
